import { useEffect, useRef } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { useAppSelector } from '../../../store/hooks'
import { selectProjectsById } from '../../../store/projects/projectsSelectors'
import { selectTasksById, selectTasksAllIds } from '../../../store/tasks/tasksSelectors'

const PageTitle = () => {
    const { pathname } = useLocation()
    const projectsById = useAppSelector(selectProjectsById)
    const tasksById = useAppSelector(selectTasksById)
    const allTaskIds = useAppSelector(selectTasksAllIds)
    const prevTitleRef = useRef('Plate')

    useEffect(() => {
        const taskMatch = matchPath('/:workspace/task/:taskId', pathname)

        if (taskMatch?.params.taskId) {
            const param = taskMatch.params.taskId
            const dashIndex = param.indexOf('-')
            if (dashIndex > 0) {
                const taskNumber = parseInt(param.substring(dashIndex + 1), 10)
                if (!isNaN(taskNumber)) {
                    const taskId = allTaskIds.find((id: string) => tasksById[id]?.number === taskNumber)
                    if (taskId) {
                        document.title = tasksById[taskId].name
                        return
                    }
                }
            }
        }

        const projectMatch = matchPath('/:workspace/projects/:projectId', pathname)

        let title = ''

        if (projectMatch?.params.projectId) {
            const project = projectsById[projectMatch.params.projectId]
            if (project) {
                title = `${project.name}`
            }
        } else if (matchPath('/:workspace/inbox', pathname)) {
            title = 'Inbox'
        } else if (matchPath('/:workspace/all-tasks', pathname)) {
            title = 'All tasks'
        } else if (matchPath('/:workspace/team', pathname)) {
            title = 'My team'
        } else if (matchPath('/:workspace/projects', pathname)) {
            title = 'Projects'
        } else if (matchPath('/:workspace', pathname)) {
            title = 'My tasks'
        }

        if (title === '') {
            title = `All your projects on one ${import.meta.env.VITE_APP_NAME}`
        }

        prevTitleRef.current = title
        document.title = title
    }, [pathname, projectsById, tasksById, allTaskIds])

    return null
}

export default PageTitle
